import { render, staticRenderFns } from "./BulkEmail.vue?vue&type=template&id=71ba816c"
import script from "./BulkEmail.vue?vue&type=script&lang=js"
export * from "./BulkEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports